import { atom } from 'jotai/index';
import { ListAtomValue, ListSettingsAtomValue } from 'shared/_components/list/types';
import { TDocProject } from 'shared/model/project';
import { LIST_SORT_BY } from 'shared/_components/list/constants';
import { DocTypeFiles } from 'shared/constants/docs';

export type ProjectListItemElement = TDocProject & {
	_totals: {
		fileCount: Partial<Record<DocTypeFiles, number>>;
	};
};

export const projectListAtom = atom<ListAtomValue<ProjectListItemElement>>({ items: [], total: 0 });

export const projectListSettingsAtom = atom<ListSettingsAtomValue>({
	showFilters: false,
	page: 1,
	filters: [],
	sortBy: LIST_SORT_BY,
});
